import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class FashionSplash extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
    super(props);
    this.state = {

    };
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='FashionSplash'>
      <div className='fsTitle'>Shop Your Style</div>
      <div className='fsTopSection'>
        <div className='fsBanner'>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/top.jpg' />
        </div>
        <div className='itemWrapper'>
          <div className='fashionItem'>
            <div className='fashionItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/fash_rings.png' />
            </div>
            <div className='fashionItemButton'>Fashion Rings</div>
          </div>
          <div className='fashionItem'>
            <div className='fashionItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/fash_earring.png' />
            </div>
            <div className='fashionItemButton'>Fashion Earrings</div>
          </div>
          <div className='fashionItem'>
            <div className='fashionItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/fash_pendants.png' />
            </div>
            <div className='fashionItemButton'>Fashion Pendants</div>
          </div>
        </div>
      </div>
      <div className='fsMidSection'>
        <div className='midCol1'>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/studs.jpg' />
        </div>
        <div className='midCol2'>
          <div className='midPromptWrapper'>
            <div className={'promptBox promptMid'}>
              <div className='promptImg'>
                <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/studs_prod.png' />
              </div>
              <div className='promptWrapper'>
                <div className='promptTitle'>Diamond Studs</div>
                <div className='promptCopy'>Diamond studs are a girl's best friend! Add elegant sparkle to any look. Perfect for everyday wear or a great gift for someone special.</div>
                <div className='promptButton'>Shop Diamond Studs</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='fsBottomSection'>
        <div className='bottomCol1'>
          <div className='smallItem'>
            <div className='smallItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/am_chain.jpg' />
            </div>
            <div className='smallItemLabel'>
              <div className='itemName'>Amethyst Chain Bracelet</div>
              <div className='itemPrice'>$260</div>
            </div>
          </div>
          <div className='smallItem'>
            <div className='smallItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/hoops.jpg' />
            </div>
            <div className='smallItemLabel'>
              <div className='itemName'>Diamond Hoop Earrings</div>
              <div className='itemPrice'>$3,020</div>
            </div>
          </div>
          <div className='smallItem'>
            <div className='smallItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/pearl.jpg' />
            </div>
            <div className='smallItemLabel'>
              <div className='itemName'>Pearl Cocktail Ring</div>
              <div className='itemPrice'>$730</div>
            </div>
          </div>
          <div className='smallItem'>
            <div className='smallItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bangle.jpg' />
            </div>
            <div className='smallItemLabel'>
              <div className='itemName'>Diamond Bangle</div>
              <div className='itemPrice'>$2,840</div>
            </div>
          </div>
        </div>
        <div className='bottomCol2'>
          <div className='largeItem'>
            <div className='largeItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/large.png' />
            </div>
            <div className='smallItemLabel'>
              <div className='itemName'>Bumble Bee Pendant</div>
              <div className='itemPrice'>$1,320</div>
            </div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default FashionSplash;

function mapStateToProps(state) {
  return {

  };
}

export const FashionSplashContainer = connect(
  mapStateToProps,
  allActionCreators
)(FashionSplash);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/splash/FashionSplash.jsx